/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { JiraCustomerSupportTicket } from '../types/support/JiraSupport';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SuperuserJiraApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchCustomerRequestsWithPagination = ({
    requestStatus,
    take,
    skip,
  }: {
    requestStatus: 'all' | 'closed' | 'open';
    take: number;
    skip: number;
  }) => {
    return this.api.get<JiraCustomerSupportTicket[]>(`administration/jira/requests`, {
      params: { requestStatus, take, skip },
    });
  };
}

export const SuperuserJiraApiService = new SuperuserJiraApiServiceClass();
